// extracted by mini-css-extract-plugin
module.exports = {"youtube":"Youtube-module--youtube--1xV4_"};